import { render, staticRenderFns } from "./show-detail.vue?vue&type=template&id=6230d312&scoped=true&"
import script from "./show-detail.vue?vue&type=script&lang=js&"
export * from "./show-detail.vue?vue&type=script&lang=js&"
import style0 from "./show-detail.vue?vue&type=style&index=0&id=6230d312&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6230d312",
  null
  
)

export default component.exports